<template>
  <div class="edit-partner-subscription">
    <CCard>
      <CCardBody>
        <h5 class="pb-2 text-primary">
          Edit Partner Subscription - {{ partnerInfo?.org_name }}
        </h5>
        <ValidationObserver ref="editPartnerSubscription" v-slot="{ handleSubmit }">
          <form id="addPartner" @submit.prevent="handleSubmit(onSubmit)">
            <table
              class="table table-striped table-hover text-center border-bottom mb-0 w-100"
            >
              <thead>
                <tr>
                  <th>Options</th>
                  <th
                    v-for="subscription in subscriptions"
                    :key="subscription.subscription_id"
                    :class="{
                      selected_opt_head:
                        subscription.subscription_id == partner.subscription_id,
                    }"
                  >
                    <CInputRadio
                      :id="'subscription-' + subscription.subscription_id"
                      :value="subscription.subscription_id"
                      @update:checked="
                        () =>
                          (partner.subscription_id =
                            subscription.subscription_id)
                      "
                      :checked="
                        subscription.subscription_id === partner.subscription_id
                      "
                      name="subscription_type"
                      :label="subscription.subscription_name"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="opt in allOptions" :key="opt.id">
                  <td>{{ opt.name }}</td>
                  <td
                    v-for="sub in subscriptions"
                    :key="sub.subscription_id"
                    style="text-align: center"
                    :class="{
                      selected_option:
                        sub.subscription_id == partner.subscription_id,
                    }"
                  >
                    <span
                      :class="{ 'text-bold': hasOption(sub, opt.id) }"
                      >{{ hasOption(sub, opt.id) ? "✓" : "" }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="text-center mx-0 mt-2 pt-4 action-area">
              <CButton
                variant="outline"
                size="lg"
                type="button"
                color="primary"
                shape="square"
                class="px-5 m-1 mt-3"
                to="/partner-list"
                >Back</CButton
              >
              <CButton
                type="submit"
                size="lg"
                color="primary"
                shape="square"
                class="px-5 m-1 mt-3"
                >Update</CButton
              >
            </div>
          </form>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import { CCardBody, CInputRadio } from "@coreui/vue";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";

export default {
  props: {
    partnerDetail: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    CInputRadio,
  },
  data() {
    return {
      partner: {
        subscription_id: null,
        old_subscription_id: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      "locationCountryInfo",
      "dialingCodeWithCountryCode",
      "getCustomerTypeList",
      "getOrganisationTypeList",
      "licenseIssuedByCountrys",
      "getLocationByCountrysID",
      "getSubscriptions",
      "getPartnerList",
      "getCusOrgSubOpts",
      "getSubscriptionByCusOrg",
    ]),
    tags() {
      return [
        "Hospital/Clinic",
        "Pharmaceuticals",
        "Education",
        "Governmental",
        "Regulatory Body",
        "Service Provider",
        "Consulting",
        "Supplier",
      ];
    },
    options() {
      return {
        customer_type: this.getCustomerTypeList || [],
        country: this.locationCountryInfo || [],
        dialingCode: this.dialingCodeWithCountryCode || [],
        organization_type: this.getOrganisationTypeList || [],
        tags: this.tags || [],
      };
    },

    subscriptions() {
      return this.getSubscriptions || [];
    },

    maxOptions() {
      const lengths = this.getSubscriptions.map((s) => s.options?.length || 0);
      return lengths.length > 0 ? Math.max(...lengths) : 0;
    },

    allOptions() {
      const map = new Map();
      this.subscriptions.forEach((sub) => {
        sub.options.forEach((opt) => {
          map.set(opt.id, { id: opt.id, name: opt.name });
        });
      });

      return Array.from(map.values()).sort((a, b) => a.id - b.id);
    },

    partnerInfo() {
      console.log(this.getSubscriptionByCusOrg);
     return this.getSubscriptionByCusOrg?.[0] || {};
    },
  },
  methods: {
    ...mapActions([
      "showToast",
      "scrollTop",
      "fetchPartnerSubscriptionTypes",
      "showLoader",
      "hideLoader",
      "fetchPartnerSubscription",
      "fetchSubscriptionByCusOrg"
    ]),
    hasOption(subscription, optionId) {
      return subscription.options.some((o) => o.id === optionId);
    },
    showToaster() {
      setTimeout(() => {
        this.isFileError = false;
        this.isFileTpeValid = false;
      }, 5000);
    },
    async onSubmit() {
      const isValid = await this.$refs.editPartnerSubscription.validate();
      if (!isValid) {
        this.showToast({
          class: "bg-danger text-white",
          message: "please fill mandatory fields!",
        });
        return;
      }
      const customer_organisation_id = this.$route.params.id;
      const payload = {
        customer_organisation_id,
        old_subscription_id: this.partner.old_subscription_id,
        new_subscription_id: this.partner.subscription_id,
      };
      this.$emit("submit", payload);
    },
    showPageToaster() {
      this.showToast({
        class: "bg-danger text-white",
        message: "Please fill mandatory fields!",
        autohide: 3000,
      });
    },
  },
  async mounted() {
    this.showLoader();
    const customer_organisation_id = this.$route.params.id;
    const appendAction = [
      this.fetchSubscriptionByCusOrg(customer_organisation_id),
      this.fetchPartnerSubscription(customer_organisation_id),
      this.fetchPartnerSubscriptionTypes(),
    ];
    await Promise.all(appendAction).then((res) => {
      this.partner['old_subscription_id'] = this.getSubscriptionByCusOrg[0]?.subscription_id;
      this.partner["subscription_id"] = this.partner['old_subscription_id'];
    });
    this.hideLoader();
    this.scrollTop();
  },
};
</script>

<style scoped lang="scss">
.edit-partner-subscription {
  color: #212529 !important;
}
.selected_option {
  background-color: #007bff;
  color: white;
}
.selected_opt_head {
  background-color: #a9d0fb;
}
</style>
